@if (model.length) {
  <ol>
    @for (item of model; track item) {
      <li>{{ item }}</li>
    }
  </ol>
}
